module.exports = __webpack_public_path__ + "img/Checkbox-Off_16px_2_Icon.aa1b02d3.svg";